var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionnaire = function SvgQuestionnaire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9794 0.523772L4.17847 1.09632C1.87076 1.1366 0.0326543 3.04001 0.0729354 5.34772L0.627245 37.1041C0.667526 39.4118 2.57094 41.2499 4.87865 41.2096L37.6796 40.6371C39.9873 40.5968 41.8254 38.6934 41.7852 36.3857L41.2308 4.6293C41.1906 2.3216 39.2871 0.483491 36.9794 0.523772Z",
    fill: "#D0CDB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7863 3.06352L6.74591 3.57042C5.70744 3.58855 4.8803 4.44508 4.89842 5.48355L5.41262 34.9418C5.43074 35.9802 6.28728 36.8074 7.32575 36.7892L36.3661 36.2823C37.4046 36.2642 38.2317 35.4077 38.2136 34.3692L37.6994 4.91101C37.6813 3.87254 36.8247 3.04539 35.7863 3.06352Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_294_4004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.403 3.05176e-05H14.6119C13.1694 3.05176e-05 12 1.16944 12 2.61197C12 4.05451 13.1694 5.22391 14.6119 5.22391H28.403C29.8455 5.22391 31.0149 4.05451 31.0149 2.61197C31.0149 1.16944 29.8455 3.05176e-05 28.403 3.05176e-05Z",
    fill: "#D0CDB1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5224 31.3145C27.7541 31.3145 32.8059 26.2626 32.8059 20.0309C32.8059 13.7991 27.7541 8.74731 21.5224 8.74731C15.2906 8.74731 10.2388 13.7991 10.2388 20.0309C10.2388 26.2626 15.2906 31.3145 21.5224 31.3145Z",
    fill: "#DA3448"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9982 23.9583C16.8993 23.9583 16.8105 23.9342 16.7318 23.8858C16.6531 23.8375 16.5919 23.7738 16.5481 23.6947C16.5026 23.6162 16.4776 23.5311 16.4731 23.4395C16.4685 23.3479 16.4932 23.2571 16.5472 23.1673L21.541 14.5411C21.595 14.4512 21.6625 14.3848 21.7437 14.3418C21.8248 14.2988 21.9103 14.2773 22 14.2773C22.0898 14.2773 22.1752 14.2988 22.2563 14.3418C22.3375 14.3848 22.4051 14.4512 22.459 14.5411L27.4528 23.1673C27.5068 23.2571 27.5315 23.3479 27.527 23.4395C27.5224 23.5311 27.4974 23.6162 27.4519 23.6947C27.4082 23.7738 27.347 23.8375 27.2682 23.8858C27.1895 23.9342 27.1007 23.9583 27.0018 23.9583H16.9982ZM22 22.3878C22.1335 22.3878 22.2454 22.3427 22.3357 22.2524C22.426 22.1621 22.4712 22.0502 22.4712 21.9167C22.4712 21.7832 22.426 21.6713 22.3357 21.581C22.2454 21.4907 22.1335 21.4455 22 21.4455C21.8665 21.4455 21.7546 21.4907 21.6643 21.581C21.574 21.6713 21.5289 21.7832 21.5289 21.9167C21.5289 22.0502 21.574 22.1621 21.6643 22.2524C21.7546 22.3427 21.8665 22.3878 22 22.3878ZM22.0002 20.8622C22.1242 20.8622 22.2281 20.8203 22.3119 20.7364C22.3956 20.6526 22.4375 20.5487 22.4375 20.4247V18.383C22.4375 18.2591 22.3956 18.1552 22.3117 18.0713C22.2278 17.9875 22.1238 17.9455 21.9998 17.9455C21.8758 17.9455 21.7719 17.9875 21.6882 18.0713C21.6044 18.1552 21.5625 18.2591 21.5625 18.383V20.4247C21.5625 20.5487 21.6045 20.6526 21.6884 20.7364C21.7722 20.8203 21.8762 20.8622 22.0002 20.8622Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_294_4004",
    x: 12,
    y: 0.0000305176,
    width: 19.6149,
    height: 6.52388,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.6,
    dy: 1.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454199 0 0 0 0 0.435399 0 0 0 0 0.259915 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_294_4004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_294_4004",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionnaire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "questionnaire.fbe2f1237f5ee2e9d4060faf04c9f182.svg";